import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

import Box from "@mui/material/Box";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";

const useStyles = height =>
  makeStyles(theme => ({
    overlay: {
      position: "relative",
      borderRadius: "20px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)",
      backgroundColor: "#E5E5E5",
    },

    empty: {
      fontSize: `${height - 30}px`,
      color: theme.palette.primary.disabled,
      position: "absolute",
      right: "15px",
      top: "15px",
    },
  }));

const FallbackImage = ({ height, width, ...props }) => {
  const classes = useStyles(height)();
  return (
    <Box
      height={height}
      width={width}
      className={clsx(!props.className && classes.overlay, props.className)}
    >
      <PhotoOutlinedIcon className={classes.empty} />
    </Box>
  );
};

export default FallbackImage;
